module.exports = __webpack_public_path__ + "assets/macbookPreview-2x.8d54331d6fbcbf3a5a680b6f923390fef5160d4995ba8c1471654e29c035d7c2.png";